module.exports = __webpack_public_path__ + "static/media/title-ru.3e7fd6ce.svg";